import React from 'react';
import { Users, Monitor, Briefcase, Target } from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    { icon: Users, title: 'Learn with Experts', description: 'Learn from highly skilled industry experts with our dynamically customized curriculum' },
    { icon: Monitor, title: 'Offline and Online Trainings', description: 'Our both training modes provide learning opportunity for non-working candidates and students.' },
    { icon: Briefcase, title: '100% Job Assistance', description: 'Our customised curriculum which is designed dynamically as per current market requirements' },
    { icon: Target, title: 'Capstone Projects', description: 'Provides opportunity to work on industry-based internships with personalised trainer guidance' },
  ];

  const topFeatures = [
    { icon: Users, title: 'Expert Tutors', description: 'All our trainers are working professionals with more than 6 years of experience in the industry.' },
    { icon: Target, title: 'Effective Courses', description: 'Whether you are a fresher or experienced professional, we always provide 100% placement assistance.' },
    { icon: Briefcase, title: 'Earn Certificate', description: 'Job-oriented training courses help students start their career after graduation quickly.' },
  ];

  return (
    <section id="about" className="features">
      {/* Background layer */}
      <div className="features-background"></div>

      {/* Actual content */}
      <div className="features-container">
        <div className="features-header">
          <span className="features-subtitle animate-fade-in-up">Why learn with us?</span>
          <h2 className="features-title animate-fade-in-up animate-delay-100">
            Start your Learning Journey Today!
          </h2>
          <p className="features-description animate-fade-in-up animate-delay-200">
            With 12+ years of experience in IT industry, we have started BEST IT Academy to provide both Offline/Online corporate level training
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div key={index} className={`feature-card animate-fade-in-up animate-delay-${(index % 4) + 1}00`}>
                <div className="feature-icon-wrapper">
                  <IconComponent size={32} />
                </div>
                <h3 className="feature-card-title">{feature.title}</h3>
                <p className="feature-card-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="features-secondary">
        <div className="features-secondary-container">
          <div className="features-secondary-header">
            <span className="features-subtitle animate-fade-in-up">Our Top Features</span>
            <h2 className="features-secondary-title animate-fade-in-up animate-delay-100">
              Achieve Your Goal With Codex Future
            </h2>
            <p className="features-secondary-description animate-fade-in-up animate-delay-200">
              Discover career paths that truly resonate with your passion & explore mentorship programs that align perfectly with you.
            </p>
          </div>

          <div className="features-secondary-grid">
            {topFeatures.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className={`feature-secondary-card animate-fade-in-up animate-delay-${(index % 3) + 1}00`}>
                  <div className="feature-secondary-icon">
                    <IconComponent size={40} />
                  </div>
                  <h3 className="feature-secondary-title">{feature.title}</h3>
                  <p className="feature-secondary-description">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
